export default "__VITE_ASSET__bcc1f88c__"